import { useState } from "react";
import Offcanvas from "react-bootstrap/Offcanvas";
import ReplyIcon from "@mui/icons-material/Reply";
import translateText, {
  LanguageDirection,
  OffcanvasClass,
  OffcanvasPlacement,
  currentLanguage,
} from "../signals/language.signal";
import { setStorage } from "../helpers/helper";
import LogoutIcon from "@mui/icons-material/Logout";
import {
  primary,
  primaryFount,
} from "../signals/Theme colors.signal";
import { Link } from "react-router-dom";
import { logClientNumber, signalPagePath } from "../signals/login.signal";
import Person2Icon from "@mui/icons-material/Person2";
import PropTypes from "prop-types";
import { clearToken } from "../helpers/auth";
import SettingsIcon from "@mui/icons-material/Settings";

function SideBar({ more, back, backFunction, title, showAccount }) {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const toggleShow = () => setShow((s) => !s);
  if (LanguageDirection.value == "ltr") {
    OffcanvasClass.value = "OffcanvasList rounded-end-4";
    OffcanvasPlacement.value = "start";
  } else {
    OffcanvasClass.value = "OffcanvasList rounded-start-4";
    OffcanvasPlacement.value = "end";
  }
  // const handelColorTheme = (event) => {
  //   const inputValue = event.target.value;
  //   primary.value = inputValue;
  //   secondary.value = convertHexToRGBA(primary.value, 0.15);
  // };
  const handelLang = (event) => {
    const selectValue = event.target.value;

    currentLanguage.value = selectValue;
    if (selectValue == "ar" || selectValue == "urdu") {
      LanguageDirection.value = "rtl";
    } else {
      LanguageDirection.value = "ltr";
    }
    setStorage("newProLang", [
      currentLanguage.value,
      LanguageDirection.value,
      OffcanvasPlacement.value,
      OffcanvasClass.value,
    ]);
  };
  setStorage("SealsRepTheme", primary.value);
  const isActive = (path) => {
    // hasJWT('sidebar');
    return location.pathname === path
      ? { fill: primary.value, color: primaryFount.value }
      : {};
  };
  return (
    <>
      <div className="w-100 pt-3 pe-3 ps-3 d-flex justify-content-between">
        {more ? (
          <SettingsIcon
            onClick={toggleShow}
            sx={{ cursor: "pointer", fontSize: 28, fill: "#cdcdcd" }}
          />
        ) : (
          <></>
        )}
        <h6 className="w-100 text-center m-0 d-flex p-0 align-items-center justify-content-center">
          {title}
        </h6>
        {showAccount ? (
          <Link
            to={signalPagePath.value ? "/profile" : "/"}
            onClick={() => window.scrollTo(0, 0)}
          >
            <div className="d-flex justify-content-center flex-column align-items-center">
              <Person2Icon
                style={isActive("/profile")}
                sx={{
                  cursor: "pointer",
                  fill: "#cdcdcd",
                  fontSize: 28,
                }}
              />{" "}
            </div>
          </Link>
        ) : (
          <></>
        )}
        {back ? (
          <ReplyIcon
            onClick={backFunction}
            sx={{ cursor: "pointer", fontSize: 28 }}
          />
        ) : (
          <></>
        )}
      </div>
      <Offcanvas
        dir={LanguageDirection.value}
        show={show}
        onHide={handleClose}
        className={OffcanvasClass.value}
        placement={OffcanvasPlacement.value}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            {translateText(currentLanguage.value, "More")}
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="position-relative">
          <p className="form-label">
            {translateText(currentLanguage.value, "LanguageTitle")}
          </p>
          <select
            className="form-select mb-3"
            value={currentLanguage.value}
            onChange={handelLang}
          >
            <option value="ar">عربي</option>
            <option value="en">English</option>
            <option value="tr">Türkçe</option>
            <option value="urdu">urdu</option>
            <option value="hi">Hindi</option>
            <option value="my">မြန်မာ</option>
          </select>

          {/* <label htmlFor="exampleColorInput" className="form-label">
            {translateText(currentLanguage.value, "AppColor")}
          </label>
          <input
            type="color"
            className="form-control form-control-color w-100"
            id="exampleColorInput"
            value={primary.value}
            title="Choose your color"
            onChange={handelColorTheme}
            placeholder={"color"}
          ></input> */}
          {logClientNumber.value ? (
            <a
              className="m-0 rounded-3 p-2 te position-absolute bottom-0 mb-3 "
              style={{
                background: primary.value,
                color: primaryFount.value,
                cursor: "pointer",
                fontWeight: "600",
                textAlign: "center",
                width: "85%",
              }}
              onClick={() => {
                clearToken();
                logClientNumber.value = null;
                signalPagePath.value = false;
              }}
            >
              {translateText(currentLanguage.value, "Logout")}
              <LogoutIcon
                sx={{ cursor: "pointer", fontSize: 24, margin: "0 10px" }}
              />
            </a>
          ) : (
            <></>
          )}
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}
SideBar.propTypes = {
  more: PropTypes.bool,
  back: PropTypes.bool,
  title: PropTypes.string,
  showAccount: PropTypes.bool,
  backFunction: PropTypes.func,
};
export default SideBar;
